/* @flow */
'use strict';

require('../lib/formValidator/adfinance.email');
require('../lib/formValidator/adfinance.phoneNumber');

let $ = require('jquery');
let form = require('../lib/form');
let cookies = require('js-cookie');

let COMPANIES_CACHE = {};
let PRODUCTS_CACHE = {};

function getCompanies(rateId, regionId)
{
    if (rateId in COMPANIES_CACHE) {
        if (regionId in COMPANIES_CACHE[rateId]) {
            return COMPANIES_CACHE[rateId][regionId];
        }
    } else {
        COMPANIES_CACHE[rateId] = {};
    }

    let result = {};

    $.ajax({
        url: '/calculator/electricity/companies/region/' + regionId + '/rate/' + rateId,
        method: 'GET',
        async: false,
        success: function (data) {
            COMPANIES_CACHE[rateId][regionId] = data;
            result = data;
        }
    });

    return result;
}

function getProducts(companyId)
{
    if (companyId in PRODUCTS_CACHE) {
        return PRODUCTS_CACHE[companyId];
    } else {
        PRODUCTS_CACHE[companyId] = {};
    }

    let result = {};

    $.ajax({
        url: '/calculator/electricity/products/companies/' + companyId,
        method: 'GET',
        async: false,
        success: function (data) {
            PRODUCTS_CACHE[companyId] = data;
            result = data;
        }
    });

    return result;
}

function setupRegionMap($form) {
    let $select = $form.find('[name$="[country_region_id]"]');
    let $mapHolder = $form.find('#map-holder');
    let $map = $mapHolder.find('.map');
    let $area = $($map.attr('usemap')).find('area');
    let $selectionMessage = $mapHolder.find('.selection-message');

    $map.maphilight({stroke: false, fillColor: "00b555", fillOpacity: 1});

    function updateSelect(countryRegionId) {
        $select.val(countryRegionId).trigger('change');
    }

    function updateMap(countryRegionId) {
        $area
            .removeClass('selected')
            .data('maphilight', {alwaysOn: false})
            .trigger('alwaysOn.maphilight')
        ;

        $area.filter('[data-country-region-id="' + countryRegionId + '"]')
            .addClass('selected')
            .data('maphilight', {alwaysOn: true})
            .trigger('alwaysOn.maphilight')
        ;

        if ($select.val()) {
            $selectionMessage.html('Vybrali jste: ' + $select.find(':selected').html()).css('visibility', 'visible');
        } else {
            $selectionMessage.css('visibility', 'hidden');
        }
    }

    $area.on('click', function (e) {
        e.preventDefault();

        let countryRegionId = $(e.currentTarget).data('country-region-id');
        updateSelect(countryRegionId);
        updateMap(countryRegionId);
    });

    $select.on('change', function () {
        let countryRegionId = $select.val();
        updateMap(countryRegionId);
    });

    updateMap($select.val());
}

function updateRates($field: $, consumerType: string) {
    const possibleValues = {};
    window.ele_rates.forEach(function (item) {
        if (item.type_id == consumerType) {
            possibleValues[item.id] = true;
        }
    });

    form.filterSelectItems($field, (option) => {
        const value = $(option).attr('value');
        return value === '' || possibleValues[value]
    });
}

function updateCircuits($field: $, consumerType: string) {
    const possibleValues = {};
    window.ele_circuits.forEach(function (item) {
        if (item.type_id == consumerType) {
            possibleValues[item.id] = true;
        }
    });

    form.filterSelectItems($field, (option) => {
        const value = $(option).attr('value');
        return value === '' || possibleValues[value]
    });
}

function updateSuppliersList($currentCompany: $, $countryRegion: $, $electricityRate: $, $accurateConsumption: $, $usagePurposes: $) {
    let countryRegion = $countryRegion.val();
    let rate = $electricityRate.val();
    let hasAccurateConsumption = $accurateConsumption.filter(':checked').val() === '1';

    if (!countryRegion) {
        form.setSelectItems($currentCompany, ['<option value="">Nejprve vyberte kraj nahoře</option>']);
        return;
    }

    if (hasAccurateConsumption && rate == '') {
        form.setSelectItems($currentCompany, ['<option value="">Nejprve vyberte sazbu</option>']);
        return;
    }

    if (!hasAccurateConsumption) {
        rate = $usagePurposes.val();
    }

    let dominantCompanies = {};
    let mostUsedCompanies = {};
    let visibleCompanies  = {};
    let dominantCompanyId = '';

    // currentValue normalne drzi filterSelectItems, tady je ale problem, ze az po filtrovani se nastavuje hodnota
    // pro 'Neznam dodavatele' a nastaveni se musi delat az potom
    const $currentOption = $currentCompany.find('option:selected');
    let currentSelector =  $currentOption.is('[data-unknown]') ? '[data-unknown]' : `[value="${$currentOption.attr('value')}"]`;

    getCompanies(rate, countryRegion).forEach(company => {
        visibleCompanies[company.id] = true;

        if (company.isMostUsed) {
            mostUsedCompanies[company.id] = true;
        }

        if (company.dominant) {
            dominantCompanies[company.id] = true;
            dominantCompanyId = company.id;
        }
    });

    const GROUP_DOMINANT  = 'Dominantní dodavatel';
    const GROUP_MOST_USED = 'Nejčastější dodavatelé';
    const GROUP_ALL       = 'Všichni dodavatelé';

    form.groupSelectItems($currentCompany, [GROUP_DOMINANT, GROUP_MOST_USED, GROUP_ALL], (option) => {
        const value = $(option).attr('value');

        if (value === '') {
            return [''];
        }

        const groups = [];

        if (visibleCompanies[value]) {
            groups.push(GROUP_ALL);

            if (dominantCompanies[value]) {
                groups.push(GROUP_DOMINANT);
            } else if (mostUsedCompanies[value]) {
                groups.push(GROUP_MOST_USED);
            }
        }

        return groups;
    });

    $currentCompany.children(`optgroup`).last().prepend(`<option value="${dominantCompanyId}" data-unknown="1">✕ Neznám dodavatele</option>`);
    $currentCompany.find(currentSelector).first().attr('selected', true);
}

function updateCurrentProductList($currentProduct: $, $currentCompany: $, $countryRegion: $, $electricityRate: $, $accurateConsumption: $, $usagePurposes: $) {
    let currentCompanyId = parseInt($currentCompany.val());
    let countryRegionId = $countryRegion.val();
    let rateId = $electricityRate.val();
    let hasAccurateConsumption = $accurateConsumption.filter(':checked').val() === '1';

    if (!hasAccurateConsumption) {
        rateId = $usagePurposes.val();
    }

    if (!currentCompanyId) {
        form.setSelectItems($currentProduct, ['<option value="">Nejprve vyberte současného dodavatele</option>']);
        return;
    }

    let visibleProducts  = {};

    // currentValue normalne drzi filterSelectItems, tady je ale problem, ze az po filtrovani se nastavuje hodnota
    // pro 'Vyberte', 'Jiny produkt' a 'Nevim' a nastaveni se musi delat az potom
    const currentValue = $currentProduct.val();
    let defaultProductId = COMPANIES_CACHE[rateId][countryRegionId].find(company => company.id === currentCompanyId).defaultProductId;
    getProducts(currentCompanyId).forEach(product => {
        visibleProducts[product.id] = true;
    });

    form.filterSelectItems($currentProduct, (option) => {
        let value = $(option).attr('value');
        return value === '' || visibleProducts[value]
    }, false);

    $currentProduct.find(`[value=""]`).attr('value', defaultProductId);
    $currentProduct.append(`<option value="${defaultProductId}">Jiný produkt</option>`);
    $currentProduct.append(`<option value="${defaultProductId}">Nevím</option>`);

    $currentProduct.find(`[value="${currentValue}"]`).first().attr('selected', true);
}

function onExternalDataReady($form: $) {
    const $currentCompany      = form.findField($form, 'company_id');
    const $currentProduct      = form.findField($form, 'actual_product_id');
    const $electricityRate     = form.findField($form, 'electricity_rate_id');
    const $countryRegion       = form.findField($form, 'country_region_id');
    const $accurateConsumption = form.findField($form, 'accurate_consumption_type_id');
    const $usagePurposes       = form.findField($form, 'usage_purpose');
    const $consumerType        = form.findField($form, 'electricity_consumer_type_id');
    const $electricityCircuit  = form.findField($form, 'electricity_circuit_id');

    // nastaveni change listeneru
    $countryRegion.on('change', function() {
        updateSuppliersList($currentCompany, $countryRegion, $electricityRate, $accurateConsumption, $usagePurposes);
    });

    $accurateConsumption.on('change', function () {
        let formDetailsBlock = $('#calc-details');

        //set class based on  value
        if($(this).val() == '1') {
            formDetailsBlock.addClass('option-1');
            formDetailsBlock.removeClass('option-2');
        } else {
            formDetailsBlock.addClass('option-2');
            formDetailsBlock.removeClass('option-1');
        }

        updateSuppliersList($currentCompany, $countryRegion, $electricityRate, $accurateConsumption, $usagePurposes);
        updateRates($electricityRate, $consumerType.val());
        updateCircuits($electricityCircuit, $consumerType.val());
    });

    $usagePurposes.on('change', function() {
        updateSuppliersList($currentCompany, $countryRegion, $electricityRate, $accurateConsumption, $usagePurposes);
    });

    $consumerType.on('change', function () {
        updateRates($electricityRate, $consumerType.val());
        updateCircuits($electricityCircuit, $consumerType.val());
    });

    $electricityRate.on('change', function() {
        updateSuppliersList($currentCompany, $countryRegion, $electricityRate, $accurateConsumption, $usagePurposes);
    });

    $currentCompany.on('change', function() {
        updateCurrentProductList($currentProduct, $currentCompany, $countryRegion, $electricityRate, $accurateConsumption, $usagePurposes);
    });

    // prednastaveni currentCompany podle aktualne nastaveneho produktu
    // drive vybrana company se ze serveru neposila
    const currentProduct = $currentProduct.val();
    if (currentProduct !== '') {
        window.ele_suppliers.some(function (product) {
            if (product.id === currentProduct) {
                $currentCompany.find(`[value="${product.company_id}"]`).first().attr('selected', true);
                return true;
            }

            return false;
        });
    }

    updateRates($electricityRate, $consumerType.val());
    updateCircuits($electricityCircuit, $consumerType.val());
    updateSuppliersList($currentCompany, $countryRegion, $electricityRate, $accurateConsumption, $usagePurposes);
    updateCurrentProductList($currentProduct, $currentCompany, $countryRegion, $electricityRate, $accurateConsumption, $usagePurposes);
}

function setupActualProductListUpdate($form) {
    const $currentCompany = form.findField($form, 'company_id');
    const $currentProduct = form.findField($form, 'actual_product_id');
    function onCompanyChange() {
        const $selectedOption = $currentCompany.find('option:selected');
        const companyId = $selectedOption.attr('value');

        form.findRow($currentProduct).toggle(companyId !== '' && $selectedOption.data('unknown') !== 1);
    }

    $currentCompany.on('change', onCompanyChange);
    onCompanyChange();

    // nacteni externich dat + inicializace poli
    if (typeof window.ele_suppliers !== 'undefined') {
        onExternalDataReady($form);

    } else {
        window.ele_rates             = [];
        window.ele_circuits          = [];
        window.ele_suppliers         = [];

        Promise.all([
            $.ajax({url: '/calculator/ele/circuit', cache: true}),
            $.ajax({url: '/calculator/ele/rate', cache: true}),
            $.ajax({url: '/calculator/ele/suppliers', cache: true}),
        ]).then(([ele_rates, ele_circuits, ele_suppliers]) => {
            window.ele_rates             = ele_rates;
            window.ele_circuits          = ele_circuits;
            window.ele_suppliers         = ele_suppliers;
            onExternalDataReady($form);
            onCompanyChange();
        }).catch(() => {
            alert('Nepodařilo se načíst některá potřebná data. Zkuste se prosím na stránku vrátit později.');
        })
    }
}

function setupValidator($form) {
    $form.jsFormValidator({
        groups: function () {
            let groups = ['Default'];
            let $accurateConsumption = $(':input[name$="[accurate_consumption_type_id]"]', $form).filter(':checked');
            let $hasFixationDate = $(':input[name$="[has_fixation_date]"]', $form).filter(':checked');

            let $electricityRate = $(':input[name$="[electricity_rate_id]"]', $form);
            let $consumptionLt = $(':input[name$="[consumption_lt]"]', $form);
            let ratesWithLt = $consumptionLt.data('block-toggle-electricityrate') || [];

            if ($accurateConsumption.length > 0) {
                if ($accurateConsumption.val() === '1') {
                    groups.push('accurate_consumption');

                    if ($hasFixationDate.length > 0 && $hasFixationDate.val() === '1') {
                        groups.push('has_fixation_date');
                    }

                    if (ratesWithLt.indexOf($electricityRate.val()) >= 0) {
                        groups.push('consumption_lt');
                    }
                } else {
                    groups.push('inaccurate_consumption');
                }
            }

            return groups;
        }
    });
}

function setupAgreementCheckbox($form) {
    let $agreement = $form.find('[name$="[agreement]"]');

    $('#terms-agreed-button').on('click', function () {
        $agreement.prop('checked', true).trigger('change');
    });
}

function storageAvailable(type) {
    try {
        var storage = window[type],
            x       = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch (e) {
        return false;
    }
}


function setupCalculation() {
    let $calculationResults = $('#calculation-results');
    if ($calculationResults.length > 0 && typeof adFinance != 'undefined') {

        let $btnMore = $('#calc-results-show-all');
        let $btnCompare = $('.compare-with');
        let $editLink = $('.edit-link');

        // po kliku na editaci zobrazit loading nez se nacte stranka prvniho kroku
        $editLink.on('click', function (e) {
            e.preventDefault();
            $('body').addClass('preload');
            window.location = $(this).attr('href');
        });

        if (cookies.get('calc-show-all-results')) {
            adFinance.load('list', 'tableSorter', {sortAttr: {visibleLimit: 0}});
            $calculationResults.children('.row').each(function () {
                $(this).show();
            });
            $btnMore.hide();
        } else {
            adFinance.load('list', 'tableSorter');
        }

        $btnMore.click(function () {
            // zobrazeni vsech vysledku
            $calculationResults.children('.row').each(function () {
                $(this).show();
            });

            // reset atributu pro table sorter -> zobrazovat vsechny vysledky
            adFinance.list.tableSorter.settings.sortAttr = {visibleLimit: 0};
            $(this).hide();

            cookies.set('calc-show-all-results', true, {expires: 1});
        });

        $btnCompare.on('click', function (e) {
            e.preventDefault();
            cookies.set('calc-show-all-results', true, {expires: 1});
            window.location = $(this).attr('href');
        });

        // podbarveni zahlavi filtru a jednotlivych polozek (sloupce)
        $('.sort-in').find('a').click(function () {

            // zjisteni indexu sloupce v zahlavi filtru
            let columnIndex = $(this).parent().index();

            // u posledniho sloupce (tlacitka, upravit udaje) nechceme radit a podbarvovat sloupec
            if (columnIndex > 3) {
                return;
            }

            $('.sorted').removeClass('sorted');
            $(this).parent().addClass('sorted');

            $calculationResults.children('.row').each(function () {
                $(this).find('.sorted').removeClass('sorted');
                $(this).children('div').each(function () {
                    // hledani sloupce na stejnem indexu pro podbarveni
                    if ($(this).index() == columnIndex) {
                        $(this).addClass('sorted');
                    }
                });
            });
        });

        setupLocalStorage();
    }
}

function setupLocalStorage() {
    if (storageAvailable('localStorage') && typeof formData != 'undefined') {

        let localStorage = window['localStorage'];
        localStorage.setItem('entry_form_data', JSON.stringify(formData));
    }
}

function setDataFromLocalStorage() {
    let $form = $('form[name="web_calculation_entryForm"]');

    if (
        $form.length === 0
        && !storageAvailable('localStorage')
        || window.location.search.length > 0 // pokud uzivatel prisel z kakulackoveho boxu napr. z clanku, tak nebrat v potaz localStorage
        && window.location.search.match(/utm_source/) === null // vyjimkou je URI s utm parametry
    ) {
        return;
    }

    let localStorage = window['localStorage'];

    // neexistuji data v localStorage
    if (!localStorage.getItem('entry_form_data')) {
        return;
    }

    let formData = JSON.parse(localStorage.getItem('entry_form_data'));

    // kontrola, zda jsou data starsi jak 14 dni
    let localStorageTimestamp = formData.timestamp; // ze serveru v sekundach
    let currentTimestamp = Date.now() / 1000; // v milisekundach, potreba prevest na sekundy
    let days = Math.round((currentTimestamp - localStorageTimestamp) / (60 * 60 * 24));

    if (days > 14) {
        localStorage.clear();
        return;
    }

    // nastaveni dat formulare
    $.each(formData, function (key, value) {
        if (key === 'country_region_id') {
            $(':input[name$="[' + key + ']"]').val(value).trigger('change');
        }
        else if (key === 'accurate_consumption_type_id') {
            let $radios = $('input:radio[name$="[accurate_consumption_type_id]"]');
            $radios.filter('[value=' + value + ']').prop('checked', true).trigger('change');
        }
        else {
            $(':input[name$="[' + key + ']"]').val(value);
        }
    });
}

$(function () {

    setupCalculation();

    let $form = $('form[name="web_calculation_entryForm"], form[name="electricity_order"]');

    if ($form.length === 0) {
        return;
    }

    setupRegionMap($form);
    setupActualProductListUpdate($form);
    setupValidator($form);
    setupAgreementCheckbox($form);
    setDataFromLocalStorage();
});



// WEBPACK FOOTER //
// ./app/Resources/assets/js/components/form.calculator.js